import {
  IInlineNode,
  IQuestionNode,
  ISimplifiedNode,
} from '../../components/ingestion/IngestedTree'
import { IQuestionShortResponse } from '../../components/ingestion/IngestionQuestions'
import { wrapP } from '../html_utility'
import {
  createMultiPartQuestion,
  createShortResponse,
} from '../nodeCreationHelpers'

// Skip this section
// we have sections procedures-1 and procedures-2
// one is in spanish, one is in english, but it's not consistent which will be which
// this section will be done manually
const InteractivesId = 'xxx-procedures-2'

export function parseStudentInteractives(lessonElement: HTMLElement) {
  const nodes: ISimplifiedNode[] = []
  const interactives = lessonElement.querySelector(`#${InteractivesId}`)
  if (!interactives) return nodes
  // interactives are in tables that are direct descendants of interactives element
  Array.from(interactives.children)
    .filter((e) => e.tagName === 'TABLE')
    .forEach((tableElement) => {
      nodes.push(...extractInteractives(tableElement as HTMLTableElement))
    })
  return nodes
}

function testForQuestion(content: string | null | undefined): boolean {
  return !!content?.match(/[0-9]+\. /)
}

function extractInteractives(table: HTMLTableElement) {
  const nodes: ISimplifiedNode[] = []
  Array.from(table.rows).forEach((row) => {
    // question content is in the second cell
    const cell = row.cells.item(1)
    if (cell && testForQuestion(cell.textContent)) {
      nodes.push(...separateInteractivesFromCellChildren(cell.children))
    }
  })
  return nodes
}

// At this point we know the cell children contain questions, we need to separate them
// and pull out multi-part questions
function separateInteractivesFromCellChildren(
  cellChildren: HTMLCollection,
): ISimplifiedNode[] {
  const isMultiPart = (elements: Element[]): boolean => {
    return !!elements.find((e) => e.tagName === 'UL')
  }
  const questionGroups = Array.from(cellChildren).reduce(
    (acc: Element[][], element) => {
      if (testForQuestion(element.textContent)) {
        acc.push([element])
      } else {
        acc[acc.length - 1]?.push(element)
      }
      return acc
    },
    [],
  )
  return questionGroups.map((group) => {
    if (isMultiPart(group)) return getMultiPartQuestion(group)
    return createQuestion(group)
  })
}

function createQuestion(parts: Element[]): IQuestionShortResponse {
  return createShortResponse({
    description: wrapP(parts.map((q) => q.outerHTML).join('')),
  })
}

function getMultiPartQuestion(parts: Element[]): IInlineNode {
  const questionContent: Element[] = []
  const multipartContent: Element[] = []
  parts.forEach((p) => {
    switch (p.tagName) {
      case 'UL':
        multipartContent.push(p)
        break
      default:
        questionContent.push(p)
    }
  })
  const questions = multipartContent.reduce((acc: IQuestionNode[], m) => {
    Array.from(m.getElementsByTagName('li')).forEach((item) => {
      acc.push(
        createShortResponse({
          description: item.innerHTML,
        }),
      )
    })
    return acc
  }, [])
  const questionText = wrapP(questionContent.map((q) => q.outerHTML).join(''))
  return createMultiPartQuestion(questionText, questions)
}
